var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-hover-primary copy-text",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value || '-')+" ")]),_c('input',{ref:"hiddenCopyFallbackInput",attrs:{"type":"hidden"},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }